import * as React from 'react';
import * as styles from './styles.css';

import { RgrTooltip } from './RgrTooltip';
import { TooltipDesktop } from '@cian/ui-kit';

export enum AgentType {
  Realtor = 'realtor',
  Agency = 'agency',
}

export interface IRgrCertificateProps {
  type: AgentType;
}

export const RgrCertificate = ({ type }: IRgrCertificateProps) => {
  return (
    <TooltipDesktop title={<RgrTooltip type={type} />} theme="white" placement="right-start">
      <div className={styles['title-icon']} />
    </TooltipDesktop>
  );
};
